export default {
  MAX_PAY_SLIP_TEXT_LENGTH: 70,
}
